module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35e5b40c044bd4eb0fc7c261271453e5.png";